var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 75,
    viewBox: "0 0 116 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4522 22.2902H85.4429V17.2569C85.4429 16.6736 84.9733 16.2 84.395 16.2H72.536C71.9577 16.2 71.488 16.6736 71.488 17.2569V22.2902H43.7124V17.2569C43.7124 16.6736 43.2427 16.2 42.6644 16.2H30.8054C30.2271 16.2 29.7575 16.6736 29.7575 17.2569V22.2902H21.7482C21.1698 22.2902 20.7002 22.7639 20.7002 23.3472V69.143C20.7002 69.7263 21.1698 70.2 21.7482 70.2H93.4522C94.0306 70.2 94.5002 69.7263 94.5002 69.143V23.3472C94.5002 22.7639 94.0306 22.2902 93.4522 22.2902ZM91.0115 66.6812H24.1889V25.809H91.0115V66.6812Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0788 39.0815H29.9639V42.2918H43.0788V39.0815Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0886 47.3005H80.2714V42.2916H85.2361V39.0814H80.2714V34.0725H77.0886V39.0814H72.1226V42.2916H77.0886V47.3005Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5099 71.0882L95.227 44.3224C96.1062 42.826 98.2933 42.826 99.1724 44.3224L114.89 71.0882C115.769 72.5953 114.675 74.4844 112.917 74.4844H81.4826C79.7243 74.4844 78.6308 72.5953 79.5099 71.0882V71.0882Z",
    fill: "#E80000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3828 68.8092C94.3828 67.2402 95.5101 66.0302 97.0744 66.0302C98.6388 66.0302 99.789 67.2402 99.789 68.8092C99.789 70.3781 98.6618 71.6112 97.0744 71.6112C95.4871 71.6112 94.3828 70.3689 94.3828 68.8092Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3797 52.3929C99.3751 51.1276 98.3491 50.1016 97.0838 50.1016C95.8185 50.1016 94.7925 51.1276 94.7925 52.3929L95.6161 62.8648V62.874C95.6161 63.6884 96.274 64.3509 97.093 64.3509C97.912 64.3509 98.5699 63.6884 98.5699 62.874V62.8648L99.3843 52.3929H99.3797Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLow);
export default __webpack_public_path__ + "static/media/batteryLow.5a5d003d4221c3712b74206c3260dcdf.svg";
export { ForwardRef as ReactComponent };